import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/services/base.service';


@Injectable({
  providedIn: 'root'
})
export class PaginationService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  getDataPage(url: string): Observable<any> {
//  getDataPage(url: string): Observable<ApiUserList | ApplicationList | ApiList | ApiManagersList> {
    const urlParts = url.split('?');
    const finalUrl = urlParts[0];
    // request params
    const requestParams = new HttpParams({fromString: urlParts[1]});

    // TODO: pass it ?
    // if (environment.preproduction) {
    //   finalUrl = '/api-preprod' + finalUrl;
    // } else if (environment.production) {
    //   finalUrl = '/api' + finalUrl;
    // }

    const httpOptions = {
      headers: this.httpHeaders(),
      params: requestParams
    };

    const start = performance.now();

    return this.httpClient.get<any>(finalUrl, httpOptions)
    .pipe(
      tap(itemList => {
        // DEBUG:
        // console.log(`Got ${itemList.paging.totalItems} items.
        //  Took ${(performance.now() - start)} ms.`);
      }),
      catchError(this.handleServerError)
    );
  }

  handleServerError(badResponse: HttpErrorResponse) {
    // DEBUG logs:
    // console.log('Error : ' , badResponse);
    if (!!badResponse.error && badResponse.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', badResponse.error.message);
    } else if (!!badResponse.error) {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${badResponse.status}, ` +
        `body was: ${badResponse.error.error ? badResponse.error.error : badResponse.message}`);
    }
    return throwError(badResponse);
  }
}
